import type { ModalName } from './redux';

export const MODAL_PARAM = 'modal';
export const SOURCE_PARAM = 'source';

export const toModalOpenParams = (modalName: ModalName) => `${MODAL_PARAM}=${modalName}`;

export const toModalOpenRecord = (modalName: ModalName) => ({
  [MODAL_PARAM]: modalName,
});
